export default __webpack_public_path__ + "static/media/Debug.be36ad0c.svg";